export default __webpack_public_path__ + "static/media/Metro.6909a029.svg";